/**
 * @desc 保存平台站点应用token
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.PlatformAppTokenRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/savePlatformAppToken`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
